import script from "./BillingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BillingPage.vue?vue&type=script&setup=true&lang=js"

import "./BillingPage.vue?vue&type=style&index=0&id=333f6b7e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-333f6b7e"]])

export default __exports__